import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatOption } from '@angular/material/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatSelect } from '@angular/material/select';
import { ExportOptions } from '@vectronic/util';
import { CardComponent } from '../../components/card/card.component';

@Component({
  selector: 'vectronic-export-csv-options',
  templateUrl: './export-csv-options.component.html',
  styleUrls: ['./export-csv-options.component.scss'],
  imports: [
    CardComponent,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatSelect,
    MatOption,
    MatButton,
    MatIcon,
  ],
})
export class ExportCsvOptionsComponent implements OnInit {
  dialogRef = inject(MatDialogRef<ExportCsvOptionsComponent>);
  private fb = inject(FormBuilder);
  data: Partial<ExportOptions> = inject(MAT_DIALOG_DATA);

  exportOptionsForm: FormGroup = this.fb.group({
    csvSeparator: [','],
    exportType: ['csv'],
    isSingleFile: [true],
  });
  exportOptions: ExportOptions = {
    csvSeparator: this.data.csvSeparator ?? ',',
    exportType: this.data.exportType ?? 'csv',
    isSingleFile: this.data.isSingleFile ?? true,
    hideMultipleFile: this.data.hideMultipleFile ?? false,
  };
  result: ExportOptions;

  ngOnInit() {
    this.setExportOptions();
  }

  setExportOptions() {
    this.exportOptionsForm.get('csvSeparator').setValue(this.exportOptions.csvSeparator);
    this.exportOptionsForm.get('isSingleFile').setValue(this.exportOptions.isSingleFile);
  }

  reset() {
    this.exportOptionsForm.reset();
    this.setExportOptions();
  }

  apply() {
    this.exportOptions = Object.assign({}, { ...this.exportOptionsForm.value });
    this.dialogRef.close(this.exportOptions);
  }
}
